import Button from "@/components/atoms/button";
import InputCheckBox from "./InputCheckBox";
import clsx from 'clsx';
import useJoinGuideView from "../useJoinGuideView";


interface IProps{
    onClick: () => void;
}

const JoinGuideView = ({ onClick }: IProps): JSX.Element => {
    const { checkboxStates,isRequiredTermsChecked, onChangeAllAgree, onChangeSingleCheck, onClickCheckBox, onClickNextBtn } = useJoinGuideView(onClick);

    return (
        <div className="wrap wrap_temporary logn">
            <div className="container">
                <h2 className="fw-b">약관동의</h2>

                <div className="terms">
                    <InputCheckBox 
                        divClassName="term-item" 
                        labelClassName="body-l-n" 
                        labelText="전체동의" 
                        id="all-agree" 
                        htmlFor="all-agree" 
                        dataModal="termsModal-all"
                        checked={checkboxStates.allAgree}
                        onChange={onChangeAllAgree}
                        onClick={onClickCheckBox}
                    />
                    <InputCheckBox 
                        divClassName="term-item" 
                        labelClassName="body-n-n" 
                        labelText="전자지갑 서비스 이용약관 (필수)" 
                        id="terms-1" 
                        htmlFor="terms-1" 
                        dataModal="termsModal-1"
                        checked={checkboxStates.terms1}
                        onChange={() => onChangeSingleCheck('terms1')}
                        onClick={onClickCheckBox}
                    />
                    <InputCheckBox 
                        divClassName="term-item" 
                        labelClassName="body-n-n" 
                        labelText="개인정보 수집 및 이용 동의 (필수)" 
                        id="terms-2" 
                        htmlFor="terms-2" 
                        dataModal="termsModal-2"
                        checked={checkboxStates.terms2} 
                        onChange={() => onChangeSingleCheck('terms2')}
                        onClick={onClickCheckBox}
                    />
                </div>

                <div className="button-area actions margin-top">
                    <Button 
                        caption="다음" 
                        className={clsx(
                            'glass-button body-n-n fw-b',
                            { 'enabled': isRequiredTermsChecked }
                        )} 
                        onClick={onClickNextBtn} 
                    />
                </div>
            </div>
        </div>
    )
};

export default JoinGuideView;